import { capitalize } from '@/utils/lodash.util';

export function parseTechnologyVersion(version: string, detailed = false) {
  const isAny = version.toLocaleLowerCase() === 'any';

  if (isAny) {
    return detailed ? 'Unknown version' : 'Unknown';
  }

  return capitalize(version).split('\\').join('');
}

export function parseTechnologyProductName(product: string) {
  return product.replace(/\\(.)/g, '$1');
}
